import { render } from "./ModalElectricityConsumer.vue?vue&type=template&id=0cc43938&scoped=true"
import script from "./ModalElectricityConsumer.vue?vue&type=script&lang=js"
export * from "./ModalElectricityConsumer.vue?vue&type=script&lang=js"

import "./ModalElectricityConsumer.vue?vue&type=style&index=0&id=0cc43938&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc43938"]])

export default __exports__